import { useMutation } from '@apollo/client';
import type { Audience_Insert_Input } from '@openx/types/gqlTypes';
import { ActivateAudienceDocument } from '../../../graphql/mutation/audiences/ActivateAudience.generated';
import { CreateAudienceDocument } from '../../../graphql/mutation/audiences/CreateAudience.generated';

export function useAudienceCreateAndActivate() {
  const [createAudienceMutation, { loading: creatingLoading }] = useMutation(CreateAudienceDocument);
  const [activateAudienceMutation, { loading: activatingLoading }] = useMutation(ActivateAudienceDocument);

  const createAudience = async (audience: Audience_Insert_Input) => {
    return await createAudienceMutation({
      variables: {
        object: audience,
      },
    });
  };

  const activateAudience = async (audienceId: string) => {
    if (!audienceId) {
      return null;
    }

    return await activateAudienceMutation({
      variables: {
        id: audienceId,
      },
    });
  };

  const createAndActivateAudience = async (audience: Audience_Insert_Input) => {
    const resp = await createAudience(audience);
    const audienceId = resp?.data?.insert_audience_one?.id;

    if (audienceId) {
      await activateAudience(audienceId);
    }

    return audienceId;
  };

  return {
    createAudience,
    activateAudience,
    createAndActivateAudience,
    loading: creatingLoading || activatingLoading,
  };
}
